export const ROUTES = {
    BRAND: {
    DASHBOARD:"/brand/dashboard",
    JOB_CAMPAIGNS:"/brand/jobCampaigns",
    JOB_POST_MAIN:"/brand/jobpostmain",
    JOB_POST_DESCRIPTION:"/brand/jobpostdescription",
    JOB_POST_BRIEF:"/brand/jobpostbrief",
    RECOMMENDATIONS:"/brand/recommendations",
    DIRECT_CAMPAIGNS:"/brand/campaigns",
    EXPLORE_INFLUENCER:"/brand/influencerdiscovery",
    INFLUENCER_LIST:"/brand/influencerlist",
    ORDERS:"/brand/orders",
    OFFERS:"/brand/offers",
    MESSAGES:"/brand/chat",
    BRIEF_GENERATOR:"/brand/briefing",
    ASK_TAMA_AGENT:"/brand/owl",
    FRAUD_DETECTION_TOOLS:"/brand/frauddetectiontools",
    REPORTS:"/brand/reports",
    ASSETS:"/brand/assets",
    BOOK_TRAINING:"https://calendly.com/darshana-munde/30min?month=2025-08",
    TAMA_COINS:"/brand/tamacoin"
    },
    INFLUENCER:{
        INFLUENCER_DASHBOARD:"/influencer/dashboard",
        MY_PROFILE:"/influencer/profile",
        RATE_MEDIA_KITS:"/influencer/social_accounts",
        GALLERY:"/influencer/gallery",
        INFLUENCER_OFFERS:"/influencer/offers",
        INFLUENCER_CHAT:"/influencer/chat",
        REFER_A_MEDIA:"/influencer/refer_friend",
        TAMA_BLOG:"https://blog.tamayou.com/",
        CONTACT_US:"https://tamayou.com/contact",
        OPPORTUNITIES:'/influencer/opportunities',
        CHAT:"/influencer/chat",
        PUBLIC_PROFILE:"/influencer/publicprofile",
    },
    MY_PROFILE:"/brand/profile",
    ADMIN:{
        ADMIN_DASHBOARD:"/admin/dashboard",
        ADMIN_PROFILE:"/admin/profile",
        CONTENT:"/admin/content",
        ADMIN_CAMPAIGNS:"/admin/campaigns",
        POST_VERIFICATION:"/admin/postverification",
        NOTIFICATIONS:"/admin/notifications",
        USERS:"/admin/admin-users",
        SIGNUP_URL:"/admin/admin-custom-url",
        TAMA_COIN:"/admin/tamacoin",
        FLUSH_CACHE:"/admin/flush",
        CRON_JOBS:"/admin/cron",
        DATA_COLLECTION:"/admin/datacollection"
    }
}
